module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAARBJREFUSEvtls1xwjAUhHdtLtxSgkugBOgkHYRUAKoAdwAl0AF0EqcDjvx6wYaDMZZsAcPAjHVevW/2aSU94sWLL+bhM4Dabns4HFbsdhPfDnk5lPQF4AfSOAeRY5LGB9oYqN2ujzCcAohKgASbzaCp21rgxdUI0tDphIxPng3JlUvnBDpc2WomIH9Jzm2CSmBjV9aqnGG9NlVtvgHe4cruNk0NO51ZUXAFlDSpPSufSGZayTAMz6nOgl3cL2kBqe9bs0a/ZBAMWuAzu9q29L1SavuOyg96MQMPnCEZkfwv3d0I0p8jZS3QEZq2pdXJeafQ7PffIO13Kgji8sySTwdpap93pKT4CdcOUc98xbNaRyl76B3DPP29AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_home.png
// module id = 7Cw6
// module chunks = 1